import React from "react";
import { Button } from "@mui/material";
import { DEBUG } from "firebaseUtil";

export function validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj === "") return false;

    if (cnpj.length !== 14) return false;

    // Elimina CNPJs invalidos conhecidos
    if (
        cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999"
    )
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado.toString() !== digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

    if (resultado.toString() !== digitos.charAt(1)) return false;

    return true;
}

export function validarCPF(strCPF) {
    var resto,
        soma = 0;

    // Usuário não digitou CPF, mas CPF não é campo obrigatório
    if (strCPF.length === 0) return true;

    // Usuário digitou CPF, mas faltou dígito
    if (strCPF.length > 0 && strCPF.length < 11) return false;

    if (strCPF === "00000000000") return false;
    if (strCPF === "11111111111") return false;
    if (strCPF === "22222222222") return false;
    if (strCPF === "33333333333") return false;
    if (strCPF === "44444444444") return false;
    if (strCPF === "55555555555") return false;
    if (strCPF === "66666666666") return false;
    if (strCPF === "77777777777") return false;
    if (strCPF === "88888888888") return false;
    if (strCPF === "99999999999") return false;

    for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) {
        resto = 0;
    }
    if (resto !== parseInt(strCPF.substring(9, 10))) {
        return false;
    }

    soma = 0;
    for (let i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
}

export function validarCEP(strCEP) {
    // Usuário não digitou CEP, mas CEP não é campo obrigatório
    if (!strCEP || strCEP.length === 0) return true;

    // Usuário digitou CEP, mas faltou dígito
    if (strCEP.length > 0 && strCEP.length < 8) return false;

    return true;
}

export function validarCelular(strCelular) {
    // Usuário não digitou celular, mas celular não é campo obrigatório
    if (!strCelular || strCelular.length === 0) return true;

    // Usuário digitou celular, mas faltou dígito
    if (strCelular.length > 0 && strCelular.length < 11) return false;

    return true;
}

export default function BotaoCriarInscricao({ change, rodada, tipo }) {
   
    const inDebug = DEBUG;
    if (!inDebug) {
     
        return "";
    }

    const gerarRelatorio = () => {
        // path, value
        // change("rodada", result[0])

        if (tipo) {
            change("tipo", "FORNECEDOR");
        }
        change("empresa.cnpj", "76.137.019/0001-46");
        change("empresa.nomeFantasia", "OK DESENVOLVIMENTO DE SISTEMAS");
        change("empresa.nomeEmpresaCracha", "OKDS");
        change("empresa.descricaoEmpresa", "DESC OKDS");
        change("empresa.funcionarios.cpf", "371.097.660-04");
        change("empresa.funcionarios.nomeParticipante", "CARLOS A. G. MARTINS");
        change("empresa.funcionarios.celular", "(67) 99691-0700");
        change("empresa.produtosVenda", [rodada.produtos[0]]);
        change("empresa.produtosCompra", [rodada.produtos[0]]);
        change("municipio", "Alvorada D'Oeste - RO");
        change("termo", true);
    };

    return (
        <div style={{ position: "fixed", bottom: 0, right: 0 }}>
            <Button style={{ whiteSpace: "nowrap", minWidth: "auto" }} onClick={gerarRelatorio}>
                Criar Inscrição
            </Button>
        </div>
    );
}
